/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeOfDay
 */
export interface TimeOfDay {
    /**
     * 
     * @type {number}
     * @memberof TimeOfDay
     */
    hours?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeOfDay
     */
    minutes?: number;
}

export function TimeOfDayFromJSON(json: any): TimeOfDay {
    return TimeOfDayFromJSONTyped(json, false);
}

export function TimeOfDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeOfDay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hours': !exists(json, 'hours') ? undefined : json['hours'],
        'minutes': !exists(json, 'minutes') ? undefined : json['minutes'],
    };
}

export function TimeOfDayToJSON(value?: TimeOfDay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hours': value.hours,
        'minutes': value.minutes,
    };
}


